var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "result tc" },
    [
      _c("van-skeleton", { attrs: { row: 4, loading: _vm.loading } }, [
        _c("img", { attrs: { src: _vm.result.src, alt: "" } }),
        _c("h3", [_vm._v(_vm._s(_vm.result.title))]),
        _c("p", { staticClass: "fs12" }, [_vm._v(_vm._s(_vm.result.desc))]),
        _c("div", { staticClass: "btns" }, [
          _c("button", { on: { click: _vm.btnClick } }, [
            _vm._v(_vm._s(_vm.result.btnsText))
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }